import { JoyrideContentStyles } from "./JoyrideContentStyles";

export const getJoyrideSerialProcessSteps = ({ isTimelinePage }) => [
  {
    target: `#root`,
    placement: "center" as any,
    disableBeacon: true,
    content: (
      <JoyrideContentStyles>
        <div>
          A serial process is arranged in a specified order, with one or more
          {`"`}constraint{`"`} or {`"`}bottleneck{`"`} machines. This affects
          how your metrics are calculated.
        </div>
        <div>
          Click {`"`}Next{`"`} to continue...
        </div>
      </JoyrideContentStyles>
    ),
  },
  {
    target: `[class*="GroupMetricsStyles"]`,
    content: (
      <JoyrideContentStyles>
        <div>
          Summary metrics and other data displayed in this section will only
          reflect the relevant machines.
        </div>
      </JoyrideContentStyles>
    ),
    spotlightPadding: -10,
  },
  {
    target: isTimelinePage
      ? `[class*="TimeAxisStyles__TimeAxisSvgStyles"]`
      : `[class*="ProcessTilesPanelStyles"]`,
    content: (
      <JoyrideContentStyles>
        <div>
          The {isTimelinePage ? "timeline indicates" : "tiles indicate"} these
          relevant machines by fading out the others.
        </div>
      </JoyrideContentStyles>
    ),
  },
  {
    target: `#root`,
    placement: "center" as any,
    content: (
      <JoyrideContentStyles>
        <div>
          This machine group was set as {`"`}serial{`"`} by your support team
          here at Raven.
        </div>
        <div>
          Please get in touch if something doesn{`'`}t look right. Thanks!
        </div>
      </JoyrideContentStyles>
    ),
  },
];
